import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@mui/material';
import './StatsPage.css';
import { calculateAllStats } from '../utils/statsCalculator';
import { getPlayerDisplayName } from '../playerDisplay';  // 🆕 AJOUT
import StatsHelpModal from './StatsHelpModal';


// Composant StatRow pour afficher une ligne de statistique
const StatRow = ({ stat }) => {
  const maxValue = stat.isCount ? Math.max(stat.j1Value, stat.j2Value, 10) : 100;
  const j1Width = (stat.j1Value / maxValue) * 100;
  const j2Width = (stat.j2Value / maxValue) * 100;

  return (
    <div className="stat-row">
      <div className="stat-row-header">
        <div className="stat-row-value stat-row-value-left" style={{ whiteSpace: 'nowrap', fontSize: '11px' }}>
          {stat.j1Total && `${stat.j1Value}% (${stat.j1Total})`}
          {!stat.j1Total && !stat.isCount && `${stat.j1Value}%`}
          {stat.isCount && stat.j1Value}
        </div>

        <div className="stat-row-name">
          {stat.name}
        </div>

        <div className="stat-row-value stat-row-value-right" style={{ whiteSpace: 'nowrap', fontSize: '11px' }}>
          {stat.j2Total && `${stat.j2Value}% (${stat.j2Total})`}
          {!stat.j2Total && !stat.isCount && `${stat.j2Value}%`}
          {stat.isCount && stat.j2Value}
        </div>
      </div>

      <div className="stat-row-bars">
        <div className="stat-row-bar-container stat-row-bar-container-left">
          <div 
            className="stat-row-bar stat-row-bar-j1"
            style={{ width: `${j1Width}%` }}
          />
        </div>

        <div className="stat-row-divider" />

        <div className="stat-row-bar-container">
          <div 
            className="stat-row-bar stat-row-bar-j2"
            style={{ width: `${j2Width}%` }}
          />
        </div>
      </div>
    </div>
  );
};

const getDefaultStats = () => ({
  service: [
    { name: 'Aces & Services gagnants', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Double fautes', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Balles de break sauvées', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' },
    { name: '% 1er service', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' },
    { name: '% Points gagnés 1er service', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' },
    { name: '% Points gagnés 2nd service', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' }
  ],
  zoneServe1: [],
  zoneServe2: [],
  return: [
    { name: 'Balles de break converties', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' },
    { name: '% points gagnés retour 1er service', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' },
    { name: '% points gagnés retour 2nd service', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' }
  ],
  points: [
    { name: 'Total nb points gagnants', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Total nb fautes directes', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Total Points gagnés', j1Value: 0, j2Value: 0, j1Total: '0/0', j2Total: '0/0' }
  ],
  fautesDetails: [
    { name: 'Nb fautes directes filet', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Nb fautes directes couloir', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Nb fautes directes longueur', j1Value: 0, j2Value: 0, isCount: true }
  ],
  jeux: [
    { name: 'Total de jeux gagnés', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Jeux de services gagnés', j1Value: 0, j2Value: 0, isCount: true },
    { name: 'Jeux de retours gagnés', j1Value: 0, j2Value: 0, isCount: true }
  ],
  effets1: [],
  effets2: [],
  effetsZones1: [],
  effetsZones2: []
});

// Fonction de calcul des statistiques (hors composant pour éviter warning React)
  const buildStatsData = (j1, j2, totalPoints) => {
    return {
      service: [
        { name: 'Aces & Services gagnants', j1Value: j1.aces, j2Value: j2.aces, isCount: true },
        { name: 'Double fautes', j1Value: j1.dfs, j2Value: j2.dfs, isCount: true },
        { 
          name: 'Balles de break sauvées', 
          j1Value: j1.breakSavedPct, 
          j2Value: j2.breakSavedPct,
          j1Total: `${j1.breakPointsSaved}/${j1.breakPointsFaced}`,
          j2Total: `${j2.breakPointsSaved}/${j2.breakPointsFaced}`
        },
        { 
          name: '% 1er service', 
          j1Value: j1.firstPct, 
          j2Value: j2.firstPct,
          j1Total: `${j1.firstServes}/${j1.totalServeAttempts}`,
          j2Total: `${j2.firstServes}/${j2.totalServeAttempts}`
        },
        { 
          name: '% Points gagnés 1er service', 
          j1Value: j1.firstWonPct, 
          j2Value: j2.firstWonPct,
          j1Total: `${j1.firstWon}/${j1.firstServes}`,
          j2Total: `${j2.firstWon}/${j2.firstServes}`
        },
        { 
          name: '% Points gagnés 2nd service', 
          j1Value: j1.secondWonPct, 
          j2Value: j2.secondWonPct,
          j1Total: `${j1.secondWon}/${j1.secondServes}`,
          j2Total: `${j2.secondWon}/${j2.secondServes}`
        }
      ],
      zoneServe1: buildZoneStats(j1.zoneStats, j2.zoneStats, true),
      zoneServe2: buildZoneStats(j1.zoneStats, j2.zoneStats, false),
      pressure: buildPressureStats(j1, j2),
      effets1: buildEffetStats(j1, j2, true),
      effets2: buildEffetStats(j1, j2, false),
      effetsZones1: buildEffetZoneStats(j1, j2, true),
      effetsZones2: buildEffetZoneStats(j1, j2, false),
      return: [
        { 
          name: 'Balles de break converties', 
          j1Value: j1.breakConvertedPct, 
          j2Value: j2.breakConvertedPct,
          j1Total: `${j1.breakPointsConverted}/${j1.breakPointsAgainst}`,
          j2Total: `${j2.breakPointsConverted}/${j2.breakPointsAgainst}`
        },
        { 
          name: '% points gagnés retour 1er service', 
          j1Value: j1.returnFirstPct, 
          j2Value: j2.returnFirstPct,
          j1Total: `${j1.returnFirstWon}/${j1.returnFirst}`,
          j2Total: `${j2.returnFirstWon}/${j2.returnFirst}`
        },
        { 
          name: '% points gagnés retour 2nd service', 
          j1Value: j1.returnSecondPct, 
          j2Value: j2.returnSecondPct,
          j1Total: `${j1.returnSecondWon}/${j1.returnSecond}`,
          j2Total: `${j2.returnSecondWon}/${j2.returnSecond}`
        }
      ],
      points: [
        { 
          name: 'Total Points gagnés', 
          j1Value: Math.round((j1.totalPoints / totalPoints) * 100), 
          j2Value: Math.round((j2.totalPoints / totalPoints) * 100),
          j1Total: `${j1.totalPoints}/${totalPoints}`,
          j2Total: `${j2.totalPoints}/${totalPoints}`
        },
        { name: 'Total nb points gagnants', j1Value: j1.winners, j2Value: j2.winners, isCount: true },
        { 
          name: '% points gagnés au service', 
          j1Value: j1.serviceWonPct, 
          j2Value: j2.serviceWonPct,
          j1Total: `${j1.totalServeWon}/${j1.totalServePoints}`,
          j2Total: `${j2.totalServeWon}/${j2.totalServePoints}`
        },
        { 
          name: '% points gagnés au retour', 
          j1Value: j1.returnWonPct, 
          j2Value: j2.returnWonPct,
          j1Total: `${j1.totalReturnWon}/${j1.totalReturnPoints}`,
          j2Total: `${j2.totalReturnWon}/${j2.totalReturnPoints}`
        },
        { 
          name: '% points gagnés au filet', 
          j1Value: j1.volleyWonPct, 
          j2Value: j2.volleyWonPct,
          j1Total: `${j1.volleyWon}/${j1.volleyTotal}`,
          j2Total: `${j2.volleyWon}/${j2.volleyTotal}`
        },
        { name: 'Total nb fautes directes', j1Value: j1.unForcedErrors, j2Value: j2.unForcedErrors, isCount: true }
      ],
      fautesDetails: [
        { name: 'Nb fautes directes filet', j1Value: j1.netErrors, j2Value: j2.netErrors, isCount: true },
        { name: 'Nb fautes directes couloir', j1Value: j1.wideErrors, j2Value: j2.wideErrors, isCount: true },
        { name: 'Nb fautes directes longueur', j1Value: j1.longErrors, j2Value: j2.longErrors, isCount: true }
      ],
      jeux: [
        { name: 'Total de jeux gagnés', j1Value: j1.gamesWon, j2Value: j2.gamesWon, isCount: true },
        { name: 'Jeux de services gagnés', j1Value: j1.gamesServing, j2Value: j2.gamesServing, isCount: true },
        { name: 'Jeux de retours gagnés', j1Value: j1.gamesReturning, j2Value: j2.gamesReturning, isCount: true }
      ]
    };
  };

  const buildZoneStats = (j1Zones, j2Zones, isFirst) => {
    const type = isFirst ? 'first' : 'second';
    const typeWon = isFirst ? 'firstWon' : 'secondWon';
    const calc = (won, total) => ({

      won: won || 0,
      total: total || 0,
      pct: total > 0 ? Math.round((won / total) * 100) : 0
    });
    
    const labels = {
      egalite: 'côté égalité',
      avantage: 'côté avantage',
      z1: 'Ext. égalité',
      z2: 'Corps égalité',
      z3: 'T égalité',
      z4: 'T avantage',
      z5: 'Corps avantage',
      z6: 'Ext. avantage'
    };
    
    return [
      ...['egalite', 'avantage'].map(z => {
        const j1 = calc(j1Zones[typeWon][z], j1Zones[type][z]);
        const j2 = calc(j2Zones[typeWon][z], j2Zones[type][z]);
        return {
          name: `% pts gagnés ${isFirst ? '1er' : '2nd'} serv ${labels[z]}`,
          j1Value: j1.pct,
          j2Value: j2.pct,
          j1Total: `${j1.won}/${j1.total}`,
          j2Total: `${j2.won}/${j2.total}`
        };
      }),
      ...['z1', 'z2', 'z3', 'z4', 'z5', 'z6'].map(z => {
        const j1 = calc(j1Zones[typeWon][z], j1Zones[type][z]);
        const j2 = calc(j2Zones[typeWon][z], j2Zones[type][z]);
        return {
          name: `% pts gagnés ${isFirst ? '1er' : '2nd'} serv ${labels[z]}`,
          j1Value: j1.pct,
          j2Value: j2.pct,
          j1Total: `${j1.won}/${j1.total}`,
          j2Total: `${j2.won}/${j2.total}`
        };
      })
    ];
  };

// 🆕 Pressure points
const buildPressureStats = (j1, j2) => {
  return [
    // 1 - Balles de break sauvées (reprise sans recalcul)
    {
      name: '% balles de break sauvées',
      j1Value: j1.breakSavedPct, j2Value: j2.breakSavedPct,
      j1Total: `${j1.breakPointsSaved}/${j1.breakPointsFaced}`,
      j2Total: `${j2.breakPointsSaved}/${j2.breakPointsFaced}`
    },
    // 2 - Balles de set sauvées
    {
      name: '% balles de set sauvées',
      j1Value: j1.setPointsSavedPct, j2Value: j2.setPointsSavedPct,
      j1Total: `${j1.setPointsSaved}/${j1.setPointsFaced}`,
      j2Total: `${j2.setPointsSaved}/${j2.setPointsFaced}`
    },
    // 3 - Balles de match sauvées
    {
      name: '% balles de match sauvées',
      j1Value: j1.matchPointsSavedPct, j2Value: j2.matchPointsSavedPct,
      j1Total: `${j1.matchPointsSaved}/${j1.matchPointsFaced}`,
      j2Total: `${j2.matchPointsSaved}/${j2.matchPointsFaced}`
    },
    // 4 - Points gagnés à 40-40
    {
      name: '% pts gagnés à 40-40 (égalité)',
      j1Value: j1.equalityWonPct, j2Value: j2.equalityWonPct,
      j1Total: `${j1.equalityWon}/${j1.equalityPoints}`,
      j2Total: `${j2.equalityWon}/${j2.equalityPoints}`
    },
    // 5 - Avantage au service
    {
      name: '% pts gagnés sur avantage (service)',
      j1Value: j1.advantageServingWonPct, j2Value: j2.advantageServingWonPct,
      j1Total: `${j1.advantageServingWon}/${j1.advantageServing}`,
      j2Total: `${j2.advantageServingWon}/${j2.advantageServing}`
    },
    // 6 - Situation critique serveur
    {
      name: '% pts gagnés situation critique (serveur)',
      j1Value: j1.criticalServingWonPct, j2Value: j2.criticalServingWonPct,
      j1Total: `${j1.criticalServingWon}/${j1.criticalServing}`,
      j2Total: `${j2.criticalServingWon}/${j2.criticalServing}`
    },
    // 7 - Situation critique retourneur
    {
      name: '% pts gagnés situation critique (retourneur)',
      j1Value: j1.criticalReturningWonPct, j2Value: j2.criticalReturningWonPct,
      j1Total: `${j1.criticalReturningWon}/${j1.criticalReturning}`,
      j2Total: `${j2.criticalReturningWon}/${j2.criticalReturning}`
    },
    // 8 - Jeux de service gagnés en situation favorable
    {
      name: '% jeux service gagnés (situation favorable)',
      j1Value: j1.favorableServeGamesWonPct, j2Value: j2.favorableServeGamesWonPct,
      j1Total: `${j1.favorableServeGamesWon}/${j1.favorableServeGames}`,
      j2Total: `${j2.favorableServeGamesWon}/${j2.favorableServeGames}`
    },
    // 9 - Jeux de retour gagnés en situation favorable
    {
      name: '% jeux retour gagnés (situation favorable)',
      j1Value: j1.favorableReturnGamesWonPct, j2Value: j2.favorableReturnGamesWonPct,
      j1Total: `${j1.favorableReturnGamesWon}/${j1.favorableReturnGames}`,
      j2Total: `${j2.favorableReturnGamesWon}/${j2.favorableReturnGames}`
    },
    // 10 - Réaction (après 2 points perdus consécutifs)
    {
      name: '% pts gagnés après 2 pts perdus',
      j1Value: j1.afterLossWonPct, j2Value: j2.afterLossWonPct,
      j1Total: `${j1.afterLossWon}/${j1.afterLossTotal}`,
      j2Total: `${j2.afterLossWon}/${j2.afterLossTotal}`
    },
    // 11 - Confirmation (après 2 points gagnés consécutifs)
    {
      name: '% pts gagnés après 2 pts gagnés',
      j1Value: j1.afterWinWonPct, j2Value: j2.afterWinWonPct,
      j1Total: `${j1.afterWinWon}/${j1.afterWinTotal}`,
      j2Total: `${j2.afterWinWon}/${j2.afterWinTotal}`
    },
    // 12 - Plus longue série de points perdus (count, pas %)
    {
      name: 'Plus longue série de points perdus',
      j1Value: j1.longestLoseStreak, j2Value: j2.longestLoseStreak,
      isCount: true
    },
  ];
};

// 🆕 Calcul stats par effet (Plat/Slicé/Lifté)
const buildEffetStats = (j1Stats, j2Stats, isFirst) => {
  const serveKey = isFirst ? 'first' : 'second';
  const label = isFirst ? '1er' : '2nd';
  const effets = [
    { code: 'P', label: 'Plat' },
    { code: 'S', label: 'Slicé' },
    { code: 'L', label: 'Lifté' }
  ];
  const calc = (won, total) => ({
    pct: total > 0 ? Math.round((won / total) * 100) : 0,
    won: won || 0,
    total: total || 0
  });
  const rows = [];
  effets.forEach(({ code, label: effLabel }) => {
    const j1e = j1Stats.effectStats?.[serveKey]?.[code] || {};
    const j2e = j2Stats.effectStats?.[serveKey]?.[code] || {};
    // Global
    const j1g = calc(j1e.won, j1e.total);
    const j2g = calc(j2e.won, j2e.total);
    rows.push({
      name: `% pts gagnés ${label} serv. ${effLabel}`,
      j1Value: j1g.pct, j2Value: j2g.pct,
      j1Total: `${j1g.won}/${j1g.total}`, j2Total: `${j2g.won}/${j2g.total}`
    });
    // Côté égalité
    const j1eq = calc(j1e.egaliteWon, j1e.egalite);
    const j2eq = calc(j2e.egaliteWon, j2e.egalite);
    rows.push({
      name: `% pts gagnés ${label} serv. égalité ${effLabel}`,
      j1Value: j1eq.pct, j2Value: j2eq.pct,
      j1Total: `${j1eq.won}/${j1eq.total}`, j2Total: `${j2eq.won}/${j2eq.total}`
    });
    // Côté avantage
    const j1av = calc(j1e.avantageWon, j1e.avantage);
    const j2av = calc(j2e.avantageWon, j2e.avantage);
    rows.push({
      name: `% pts gagnés ${label} serv. avantage ${effLabel}`,
      j1Value: j1av.pct, j2Value: j2av.pct,
      j1Total: `${j1av.won}/${j1av.total}`, j2Total: `${j2av.won}/${j2av.total}`
    });
  });
  return rows;
};

// 🆕 Calcul stats par effet ET zone
const buildEffetZoneStats = (j1Stats, j2Stats, isFirst) => {
  const serveKey = isFirst ? 'first' : 'second';
  const label = isFirst ? '1er' : '2nd';
  const effets = [
    { code: 'P', label: 'Plat' },
    { code: 'S', label: 'Slicé' },
    { code: 'L', label: 'Lifté' }
  ];
  const zones = [
    { code: 'z1', label: 'Ext. égalité' },
    { code: 'z2', label: 'Corps égalité' },
    { code: 'z3', label: 'T égalité' },
    { code: 'z4', label: 'T avantage' },
    { code: 'z5', label: 'Corps avantage' },
    { code: 'z6', label: 'Ext. avantage' }
  ];
  const calc = (won, total) => ({
    pct: total > 0 ? Math.round((won / total) * 100) : 0,
    won: won || 0,
    total: total || 0
  });
  const rows = [];
  effets.forEach(({ code, label: effLabel }) => {
    zones.forEach(({ code: zCode, label: zLabel }) => {
      const j1ez = j1Stats.effectZoneStats?.[serveKey]?.[code] || {};
      const j2ez = j2Stats.effectZoneStats?.[serveKey]?.[code] || {};
      const j1c = calc(j1ez[`${zCode}Won`], j1ez[zCode]);
      const j2c = calc(j2ez[`${zCode}Won`], j2ez[zCode]);
      rows.push({
        name: `% pts gagnés ${label} serv. ${zLabel} ${effLabel}`,
        j1Value: j1c.pct, j2Value: j2c.pct,
        j1Total: `${j1c.won}/${j1c.total}`, j2Total: `${j2c.won}/${j2c.total}`
      });
    });
  });
  return rows;
};

// Composant principal
const StatsGeneral = ({ match }) => {
  // 🆕 DEBUG
  console.log('🟢 StatsGeneral monté');
  console.log('🟢 Match:', match);
  console.log('🟢 Match.id:', match?.id);
  console.log('🟢 Match.matchId:', match?.matchId);
  console.log('🟢 engineState?', !!match?.engineState);
  console.log('🟢 Points?', match?.engineState?.points?.length);
  
  const [tab, setTab] = useState(0);
  const [stats, setStats] = useState(getDefaultStats());
  const [showZones1, setShowZones1] = useState(false);
  const [showZones2, setShowZones2] = useState(false);
  const [showFautes, setShowFautes] = useState(false);
  const [showPressure, setShowPressure] = useState(false);
  const [showEffets1, setShowEffets1] = useState(false);
  const [showEffets2, setShowEffets2] = useState(false);
  const [showEffetsZones1, setShowEffetsZones1] = useState(false);
  const [showEffetsZones2, setShowEffetsZones2] = useState(false);
  const [helpSection, setHelpSection] = useState(null);
  const [playerNames, setPlayerNames] = useState({ joueur1: 'Joueur 1', joueur2: 'Joueur 2' });
  const [matchFormat, setMatchFormat] = useState('BEST_OF_3');

  useEffect(() => {
    // 🆕 Accepter id OU matchId
    const matchIdentifier = match?.id || match?.matchId;
    if (!matchIdentifier) {
      console.log('⚠️ Pas d\'identifiant');
      return;
    }
    
    console.log('✅ Match ID:', matchIdentifier);
    
    // ✅ Récupérer les noms des joueurs (prénoms si disponibles) et le format depuis match (props)
    console.log('🔍 Match reçu en props:', match);
    setPlayerNames({
      joueur1: getPlayerDisplayName(match, "J1"),
      joueur2: getPlayerDisplayName(match, "J2")
    });
    console.log('✅ Noms récupérés:', { 
      joueur1: getPlayerDisplayName(match, "J1"), 
      joueur2: getPlayerDisplayName(match, "J2") 
    });
    
    if (match.formatMatch) {
      setMatchFormat(match.formatMatch);
      console.log('✅ Format récupéré depuis props:', match.formatMatch);
    }
    
    try {
      // 🆕 Utiliser engineState directement
      if (!match.engineState?.points) {
        console.log('⚠️ Pas d\'engineState');
        setStats(getDefaultStats());
        return;
      }
      
      const points = match.engineState.points;
      console.log(`✅ ${points.length} points trouvés`);
      
      if (points.length === 0) {
        console.log('Aucun point trouvé');
        setStats(getDefaultStats());
        return;
      }
      
      const filteredPoints = tab === 0 
        ? points
        : points.filter(p => p.setNumero === tab);
      
      if (filteredPoints.length === 0) {
        console.log(`Aucun point trouvé pour set ${tab}`);
        setStats(getDefaultStats());
        return;
      }
      
      const j1Stats = calculateAllStats(filteredPoints, 'J1');
      const j2Stats = calculateAllStats(filteredPoints, 'J2');
      
      setStats(buildStatsData(j1Stats, j2Stats, filteredPoints.length));
    } catch (e) {
      console.error('Erreur lors du calcul des stats:', e);
      setStats(getDefaultStats());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match, tab]);


  // 🆕 Vérifications
  if (!match || (!match.id && !match.matchId)) {
    return (
      <div className="stats-container">
        <p className="no-match-message">
          Aucun match sélectionné
        </p>
      </div>
    );
  }
  
  if (!match.engineState?.points) {
    return (
      <div className="stats-container">
        <p className="no-match-message">
          Aucune donnée de points disponible
        </p>
      </div>
    );
  }

  return (
    <>
    <div id="stats-general-container">
      {/* Onglets de sélection Set */}
      <Tabs 
        value={tab} 
        onChange={(_, newTab) => setTab(newTab)} 
        centered 
        sx={{ 
          mb: 1,
          '& .MuiTab-root': {
            fontSize: matchFormat === 'BEST_OF_5' ? '10px' : '11px',
            textTransform: 'lowercase',
            minHeight: '40px',
            minWidth: matchFormat === 'BEST_OF_5' ? '60px' : 'auto',
            padding: matchFormat === 'BEST_OF_5' ? '6px 8px' : '6px 16px',
            fontWeight: 600,
            color: '#666'
          },
          '& .Mui-selected': {
            color: '#1976D2 !important',
            fontWeight: 700
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#1976D2',
            height: '3px',
            bottom: '8px'
          }
        }}
      >
        <Tab label="match complet" />
        <Tab label="set 1" />
        <Tab label="set 2" />
        <Tab label="set 3" />
        {matchFormat === 'BEST_OF_5' && [
          <Tab key="set4" label="set 4" />,
          <Tab key="set5" label="set 5" />
        ]}
      </Tabs>

      {/* Header joueurs */}
      <div className="players-header">
        <div className="player-info">
          <div className="player-color-box player-color-j1" />
          <span className="player-name">
            {playerNames.joueur1}
          </span>
        </div>
        <div className="player-info">
          <span className="player-name">
            {playerNames.joueur2}
          </span>
          <div className="player-color-box player-color-j2" />
        </div>
      </div>

      {/* Section Service */}
      <div className="stats-section">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '8px 0' }}>
          <h3 className="stats-section-title" style={{ margin: 0 }}>Service</h3>
          <button onClick={() => setHelpSection('SERVICE')} style={{ width: '22px', height: '22px', borderRadius: '50%', border: 'none', backgroundColor: '#1976D2', color: 'white', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0 }}>?</button>
        </div>
        
        {stats.service.map((stat, i) => <StatRow key={i} stat={stat} />)}
        
        {/* Boutons dépliables sur la même ligne */}
        <div className="expandable-buttons-row">
          <button
            onClick={() => setShowZones1(!showZones1)}
            className="expandable-button"
          >
            <span>{showZones1 ? '−' : '+'}</span>
            <span>Zones 1er service</span>
          </button>
          
          <button
            onClick={() => setShowZones2(!showZones2)}
            className="expandable-button"
          >
            <span>{showZones2 ? '−' : '+'}</span>
            <span>Zones 2nd service</span>
          </button>
        </div>
        
        {/* Stats zones 1er service */}
        {showZones1 && (
          <div className="expandable-section">
            {stats.zoneServe1.map((stat, i) => <StatRow key={`z1-${i}`} stat={stat} />)}
          </div>
        )}
        
        {/* Stats zones 2nd service */}
        {showZones2 && (
          <div className="expandable-section">
            {stats.zoneServe2.map((stat, i) => <StatRow key={`z2-${i}`} stat={stat} />)}
          </div>
        )}

        {/* 🆕 Boutons effets */}
        <div className="expandable-buttons-row">
          <button
            onClick={() => setShowEffets1(!showEffets1)}
            className="expandable-button"
          >
            <span>{showEffets1 ? '−' : '+'}</span>
            <span>Effets 1er service</span>
          </button>
          <button
            onClick={() => setShowEffets2(!showEffets2)}
            className="expandable-button"
          >
            <span>{showEffets2 ? '−' : '+'}</span>
            <span>Effets 2nd service</span>
          </button>
        </div>

        {showEffets1 && (
          <div className="expandable-section">
            {stats.effets1.map((stat, i) => <StatRow key={`eff1-${i}`} stat={stat} />)}
          </div>
        )}
        {showEffets2 && (
          <div className="expandable-section">
            {stats.effets2.map((stat, i) => <StatRow key={`eff2-${i}`} stat={stat} />)}
          </div>
        )}

        {/* 🆕 Boutons effets & zones */}
        <div className="expandable-buttons-row">
          <button
            onClick={() => setShowEffetsZones1(!showEffetsZones1)}
            className="expandable-button"
          >
            <span>{showEffetsZones1 ? '−' : '+'}</span>
            <span>Effets & zones 1er serv</span>
          </button>
          <button
            onClick={() => setShowEffetsZones2(!showEffetsZones2)}
            className="expandable-button"
          >
            <span>{showEffetsZones2 ? '−' : '+'}</span>
            <span>Effets & zones 2nd serv</span>
          </button>
        </div>

        {showEffetsZones1 && (
          <div className="expandable-section">
            {stats.effetsZones1.map((stat, i) => <StatRow key={`effz1-${i}`} stat={stat} />)}
          </div>
        )}
        {showEffetsZones2 && (
          <div className="expandable-section">
            {stats.effetsZones2.map((stat, i) => <StatRow key={`effz2-${i}`} stat={stat} />)}
          </div>
        )}
      </div>

      {/* Section Retour */}
      <div className="stats-section">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '8px 0' }}>
          <h3 className="stats-section-title" style={{ margin: 0 }}>Retour</h3>
          <button onClick={() => setHelpSection('RETOUR')} style={{ width: '22px', height: '22px', borderRadius: '50%', border: 'none', backgroundColor: '#FF9800', color: 'white', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0 }}>?</button>
        </div>
        {stats.return.map((stat, i) => <StatRow key={i} stat={stat} />)}
      </div>

      {/* Section Points */}
      <div className="stats-section">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '8px 0' }}>
          <h3 className="stats-section-title" style={{ margin: 0 }}>Points</h3>
          <button onClick={() => setHelpSection('POINTS')} style={{ width: '22px', height: '22px', borderRadius: '50%', border: 'none', backgroundColor: '#388E3C', color: 'white', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0 }}>?</button>
        </div>
        {stats.points.map((stat, i) => <StatRow key={i} stat={stat} />)}
        
        {/* Bouton dépliable fautes directes */}
        <button
          onClick={() => setShowFautes(!showFautes)}
          className="expandable-button-full"
        >
          <span>{showFautes ? '−' : '+'}</span>
          <span>Détails fautes directes</span>
        </button>
        
        {/* Détails fautes directes */}
        {showFautes && (
          <div className="expandable-section">
            {stats.fautesDetails.map((stat, i) => <StatRow key={`faute-${i}`} stat={stat} />)}
          </div>
        )}

        {/* 🆕 Bouton Pressure Points */}
        <button
          onClick={() => setShowPressure(!showPressure)}
          className="expandable-button"
          style={{ width: '100%', marginTop: '8px' }}
        >
          <span>{showPressure ? '−' : '+'}</span>
          <span>Points sous pression</span>
        </button>

        {showPressure && (
          <div className="expandable-section">
            {stats.pressure.map((stat, i) => <StatRow key={`pp-${i}`} stat={stat} />)}
          </div>
        )}
      </div>

      {/* Section Jeux */}
      <div className="stats-section">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: '8px 0' }}>
          <h3 className="stats-section-title" style={{ margin: 0 }}>Jeux</h3>
          <button onClick={() => setHelpSection('JEUX')} style={{ width: '22px', height: '22px', borderRadius: '50%', border: 'none', backgroundColor: '#7B1FA2', color: 'white', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0 }}>?</button>
        </div>
        {stats.jeux && stats.jeux.map((stat, i) => <StatRow key={i} stat={stat} />)}
      </div>
    </div>
    {helpSection && <StatsHelpModal section={helpSection} onClose={() => setHelpSection(null)} />}
    </>
  );
};

export default StatsGeneral;